/* wg-pdp-stickybar.js - Wade Greens
   The chat half of the sticky bar. Read assets/wg-pdp-stickybar.css first -
   it holds the measurements, the specificity note and the other three
   controls. This file only moves the Shopify Inbox bubble into the bar.

   WHY A SCRIPT. The bubble is <shopify-chat>, a web component, and its
   activator button lives in a SHADOW ROOT:

     shopify-chat                 position fixed, z-index 9999 (capped by
                                  wg-chat-fix.js), display grid, fills the
                                  viewport
       #shadow-root
         button.activator         position fixed, bottom 13px, left 15px

   A page stylesheet cannot cross that boundary, and ::part() is not exposed,
   so the rules are appended to the shadow root itself. That is the supported
   way in: nothing is overwritten, a <style> of our own is added beside theirs.

   WHAT IT MATCHES. The offsets below are the same ones in the .css half, and
   the chrome is wg-pdp-buttons.css's bar language - 44x44, 5px radius,
   transparent ground, 1px rgba(255,255,255,.55) hairline, white icon - so the
   bubble reads as one of the four controls instead of a white circle sitting
   on a black bar. Measured after: chat 12-56, sold out 68-257, gotop 266-310,
   wishlist 324-368, all on y 761, all 44 tall.

   PRODUCT PAGES ONLY. Everywhere else the bubble keeps its own corner, so the
   style is only injected on body.template-product, and it is scoped inside
   max-width:767px exactly like the stylesheet.

   IT RE-APPLIES. Inbox mounts late and re-injects on navigation - that is why
   wg-chat-fix.js watches for it rather than running once - so this polls for
   the element, stops as soon as the style is in, and gives up after 15s. The
   marker id is checked first, so repeated runs never stack duplicate styles.

   THE GROUND IS #000000, NOT transparent - the bar hides itself at some
   scroll positions and the activator, being position:fixed, stays put. See
   the matching note in the .css half.

   DO NOT ALSO MOVE THE NODE. wg-chat-fix.js re-parents <shopify-chat> to
   <body> because Inbox drops it inside the mobile menu drawer, where it is
   invisible. Moving it again, into the bar, would put it back inside a
   transformed, sometimes-hidden container and undo that fix. The activator is
   position:fixed, so positioning it is enough - it paints over the bar at the
   host's z-index 9999, above the bar's 98.
*/
(function () {
  'use strict';

  var MARK = 'wg-pdp-stickybar';

  var CSS = [
    '@media (max-width: 767px) {',
    '  .activator {',
    '    bottom: 7px !important;',
    '    left: 12px !important;',
    '    right: auto !important;',
    '    width: 44px !important;',
    '    height: 44px !important;',
    '    min-width: 0 !important;',
    '    min-height: 0 !important;',
    '    border-radius: 5px !important;',
    '    background: #000000 !important;',
    '    border: 1px solid rgba(255, 255, 255, .55) !important;',
    '    color: #ffffff !important;',
    '    box-shadow: none !important;',
    '  }',
    '  .activator__icon, .activator svg {',
    '    color: #ffffff !important;',
    '    fill: #ffffff !important;',
    '    width: 22px !important;',
    '    height: 22px !important;',
    '  }',
    '}'
  ].join('\n');

  function inject() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return false;
    if (chat.shadowRoot.getElementById(MARK)) return true;
    var s = document.createElement('style');
    s.id = MARK;
    s.textContent = CSS;
    chat.shadowRoot.appendChild(s);
    return true;
  }

  function start() {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;
    if (inject()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (inject() || tries > 30) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
